import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';

EDC.Games.CountTheTallyMarks.Scenes.Main = function () {
  BaseMinigamesMain.apply(this, [EDC.Games.CountTheTallyMarks, 59]);
  this.gameConfig = store.getters['games/getGameById']().sets[0].config;
  this.gameData = EDC.Games.CountTheTallyMarks.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.sticks = [];
  this.buttons = [];
};

EDC.Games.CountTheTallyMarks.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.CountTheTallyMarks.Scenes.Main.prototype.constructor = EDC.Games.CountTheTallyMarks.Scenes.Main;

const CTTM = EDC.Games.CountTheTallyMarks.Scenes.Main.prototype;

CTTM.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

CTTM.loadIteration = function () {
  this.createSticks();
  this.createButtons();
};

CTTM.createTemplateUI = function () {
  const title = this.add.sprite(230, 200, 'title').setScale(0.95);
  const instruction1 = this.add.sprite(980, 230, 'instructions-1');
  const instruction2 = this.add.sprite(980, 835, 'instructions-2');
  const beaver = this.add.sprite(1690, 820, 'beaver').setScale(0.95);
};

CTTM.createButtons = function () {
  const { answers } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  let x = 240;
  const y = 950;
  const font = {
    font: '70px Arial',
    fill: 'white',
    textShadow: '10px 10px black;',
    align: 'center',
    stroke: '#000',
    strokeThickness: 10,
  };
  for (let i = 0; i < 3; i++) {
    x += 370;
    const buttonContainer = this.add.container(x, y);
    const button = this.add.sprite(0, 10, 'button');
    buttonContainer.answer = answers[i];
    const numberText = this.add.text(0, 0, buttonContainer.answer, font).setOrigin(0.5);
    buttonContainer.setSize(button.width, 200);
    buttonContainer.add(button);
    buttonContainer.add(numberText);
    const rect = new Phaser.Geom.Rectangle(-50, 0, 250, 200);
    this.buttonAnimation(buttonContainer);
    buttonContainer.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
    const markAnim = new AnswerMark(this, buttonContainer).setScale(0.35);
    buttonContainer.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(buttonContainer);
    buttonContainer.on('pointerover', this.addHighlight.bind(this, buttonContainer), this);
    buttonContainer.on('pointerout', this.removeHighlight.bind(this, buttonContainer), this);
    buttonContainer.on('pointerdown', this.checkAnswer.bind(this, buttonContainer), this);
    this.buttons.push(buttonContainer);
  }
};

CTTM.addHighlight = function (button) {
  button.first.setTint(0xa0a0a0);
};

CTTM.removeHighlight = function (button) {
  if (!button.disabled) {
    button.first.clearTint();
  }
};

CTTM.buttonAnimation = function (button) {
  button.scaleAnimation = this.tweens.add({
    targets: button,
    scaleX: 1.1,
    scaleY: 1.1,
    ease: 'Linear',
    duration: 300,
    delay: 6000,
    yoyo: true,
    onComplete: this.buttonAnimation.bind(this, button),
  });
};

CTTM.checkAnswer = function (button) {
  const answer = button.answer;
  const { stickCount } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  if (answer === stickCount) {
    this.playCorrect();
    button.getData('markAnim').showMark(true, () => {});
    this.buttons.map((x) => {
      x.disableInteractive();
      x.scaleAnimation.stop();
      return true;
    });
    this.sticks.map((x) => {
      x.angleAnimation.stop();
      return true;
    });
    this.time.delayedCall(2000, this.nextIteration, [], this);
  } else {
    button.disabled = true;
    button.disableInteractive();
    button.getData('markAnim').showMark(false, () => {});
    button.last.setTint(0xff6347);
    button.first.setTint(0xff0000);
    button.scaleAnimation.stop();
    this.playWrong();
  }
};

CTTM.nextIteration = function () {
  this.buttons.map((x) => {
    x.destroy();
    return true;
  });
  this.buttons = [];
  this.sticks.map((x) => {
    x.destroy();
    return true;
  });
  this.sticks = [];
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

CTTM.createSticks = function () {
  let x = 500;
  const y = 570;
  const { stickCount } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  for (let i = 0; i < stickCount; i++) {
    if ((i + 1) % 5 === 0) {
      const stick = this.add.sprite(x - 75, y - 5, 'stick').setAngle(-45);
      this.stickAnimation(stick);
      this.sticks.push(stick);
      x += 25;
    } else {
      x += 50;
      const stick = this.add.sprite(x, y, 'stick');
      this.stickAnimation(stick);
      this.sticks.push(stick);
    }
  }
};

CTTM.stickAnimation = function (stick) {
  stick.angleAnimation = this.tweens.add({
    targets: stick,
    angle: stick.angle + 5,
    ease: 'Linear',
    duration: 150,
    delay: 6000,
    repeat: 3,
    yoyo: true,
    onComplete: this.stickAnimation.bind(this, stick),
  });
};

export default EDC.Games.CountTheTallyMarks.Scenes.Main;
